import { ErrorOutline, OpenInNew } from "@mui/icons-material";
import type React from "react";
import Button from "~/components/ui/button";
import Modal from "~/components/ui/modal";
import styles from "./index.module.scss";

interface NewApiWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const NewApiWarningModal: React.FC<NewApiWarningModalProps> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      label="kintone新機能の有効化について"
      isOpen={isOpen}
      onClose={onClose}
      className={styles["newApiWarningModal"] ?? ""}
      content={
        <div className={styles["modalContent"]}>
          <div className={styles["heroSection"]}>
            <div className={styles["iconWrapper"]}>
              <ErrorOutline className={styles["warningIcon"] ?? ""} />
            </div>
            <h2 className={styles["heroTitle"]}>kintone新機能の有効化が必要です</h2>
            <p className={styles["heroSubtitle"]}>
              アプリ生成機能はkintone新機能（API Lab）を使用しています
            </p>
          </div>

          <div className={styles["contentSection"]}>
            <div className={styles["infoCard"]}>
              <p className={styles["infoText"]}>
                この機能を利用するには、kintone管理者が事前に
                <strong>新機能を有効化</strong>する必要があります。
                有効化されていない場合、アプリ生成が正常に動作しない可能性があります。
              </p>
            </div>

            <div className={styles["linksSection"]}>
              <p className={styles["linksLabel"]}>設定方法・詳細情報</p>
              <div className={styles["linkCards"]}>
                <a
                  href="https://jp.kintone.help/k/ja/id/04051#new_feature_target_features_409542"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["linkCard"]}
                >
                  <span className={styles["linkTitle"]}>対象となる新機能一覧</span>
                  <span className={styles["linkDescription"]}>有効化が必要な機能を確認</span>
                  <OpenInNew className={styles["linkIcon"] ?? ""} />
                </a>
                <a
                  href="https://jp.kintone.help/k/ja/id/04050#new_feature_new_feature_overview_20"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["linkCard"]}
                >
                  <span className={styles["linkTitle"]}>有効化の設定方法</span>
                  <span className={styles["linkDescription"]}>管理画面での設定手順</span>
                  <OpenInNew className={styles["linkIcon"] ?? ""} />
                </a>
              </div>
            </div>
          </div>

          <div className={styles["buttonContainer"]}>
            <Button styleType="white-middle" label="キャンセル" onClick={onClose} />
            <Button styleType="blue-middle" label="確認して続行" onClick={onConfirm} />
          </div>
        </div>
      }
    />
  );
};

export default NewApiWarningModal;
